export default {
  button: {
    alignItems: 'center',
    borderRadius: 5,
    borderStyle: 'solid',
    borderWidth: 1,
    fontFamily: 'Montserrat',
    padding: '.5em',
  },
};
